<template>
  <div class="content_block">
    <div class="top">
      <b>委托人身份证<span v-if="isShowHead">此项信息为非必填，如需维护，请将带<i>*</i>号信息补充完整。</span></b>
      <template v-if="!isDisabled">
        <div class="btnContainer" v-if="isEditing">
          <el-button type="default" size="mini"  @click="handleCancel" v-if="!isShowHead">取消</el-button>
          <el-button type="primary" size="mini" @click="handleSave" v-if="!isShowHead">保存</el-button>
          <el-button type="primary" size="mini" @click="handleUpdate" v-else>保存</el-button>
        </div>
        <div class="btnContainer" v-else>
          <el-button type="primary" plain icon="el-icon-edit" size="mini" @click="handleEdit">编辑</el-button>
        </div>
      </template>
    </div>
    <template v-if="isEditing">
      <el-form :model="form" ref="JZForm" :rules="rules" label-width="140px" label-position="right">
        <el-row>
          <el-col :span="12">
            <el-form-item label="委托人身份证号" prop="certCode">
              <el-input v-model="form.certCode" placeholder="请输入委托人身份证号" maxlength="20" show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证发证日期" prop="establishDate">
              <el-date-picker
                v-model="form.establishDate"
                type="date"
                placeholder="请选择身份证发证日期"
                value-format="yyyy-MM-dd"
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证到期日期" prop="dueDate">
              <el-date-picker
                v-model="form.dueDate"
                type="date"
                placeholder="请选择身份证到期日期"
                value-format="yyyy-MM-dd"
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件信息" prop='tenantFileReqDTOs'>
              <Upload
                v-model="form.tenantFileReqDTOs"
                label="附件信息"
                buttonText="上传"
                type="single"
                :show-file-list="false"
                @success="handleFileLists"
                @remove="handleRemove"
                accept="image/png,image/jpeg,image/jpg,application/pdf"
                :maxSize="10"
                size="origin"
                :limit="10"
              >
              </Upload>
            </el-form-item>
          </el-col>
          <el-col :span="24"  v-if="form.tenantFileReqDTOs&&form.tenantFileReqDTOs.length">
            <el-form-item label="">
              <ul class="imgContainer">
                <li v-for="(img,index) in form.tenantFileReqDTOs" :key="img.url">
                  <div class="left">
                    <el-link type="primary" :href="img.url" :underline="false" target="blank">
                    <span class="name" :title='img.name'><img :src="require('@/assets/pdf.svg')" />{{ img.name }}</span>
                  </el-link>
                  </div>
                  <div class="right">
                    <i class="el-icon-success" style="color:#67C23A;margin-right: 8px;font-size:16px;"></i>
                    <i class="el-icon-delete" style="color:#409EFF;font-size:16px;cursor: pointer;" @click="handleDelete(index)"></i>
                  </div>
                </li>
              </ul>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <el-descriptions :colon="false" :column="2" style="margin-top: 10px;" v-else>
      <el-descriptions-item label="委托人身份证号" labelClassName="warningLabel" contentClassName="warningContent">{{ form.certCode }}</el-descriptions-item>
      <el-descriptions-item label="身份证发证日期" labelClassName="warningLabel" contentClassName="warningContent">{{ form.establishDate }}</el-descriptions-item>
      <el-descriptions-item label="身份证到期日期" :span="2" labelClassName="warningLabel" contentClassName="warningContent">{{ form.dueDate }}</el-descriptions-item>
      <el-descriptions-item label="附件信息" :span="2" labelClassName="warningLabel" contentClassName="warningContent">
        <div v-for="img in form.tenantFileReqDTOs" :key="img.url" class="fileContainer">
          <i class="el-icon-document" style="color:#FF5959;margin-right:4px;"></i><el-link type="primary" :href="img.url" :underline="false" target="blank"> {{ img.name }}</el-link>
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  name: '',
  components: {
    Upload: ()=>import('@/components/common/upload'),
  },
  props: {
    certificateLists: {
      type: Array,
      default () {
        return [];
      },
    },
    type: {
      type: String,
      default: '12',
    },
    isDisabled: {
      type: Boolean,
      default () {
        return false;
      },
    },
    isShowHead: {
      type: Boolean,
      default () {
        return false;
      },
    },
    activeName: {
      type: String,
      default: '',
    },
  },
  watch: {
    activeName: {
      handler (val) {
        if (val === 'TrusteeIdentityCard') {
          let info = this.certificateLists.find(i=>i.type === this.type);
          info = info ? JSON.parse(JSON.stringify(info)) : null;
          this.form = info ? {
            ...info,
            establishDate: info && info.establishDate ? this.$options.filters['date-format'](info.establishDate, 'YYYY-MM-DD') : '',
            dueDate: info && info.dueDate ? this.$options.filters['date-format'](info.dueDate, 'YYYY-MM-DD') : '',
          } : {
            certCode: '',
            establishDate: '',
            dueDate: '',
            businessRange: '',
            tenantFileReqDTOs: [],
            type: this.type,
          };
          this.clearValidate();
        }
      },
      immediate: true,
      deep: true,
    },
    isShowHead: {
      handler (val) {
        if (val) {
          this.isEditing = this.isShowHead;
        }
      },
      immediate: true,
      deep: true,
    },
    certificateLists: {
      handler (val) {
        if (val && val.length) {
          let info = val.find(i=>i.type === this.type);
          info = info ? JSON.parse(JSON.stringify(info)) : null;
          this.form = info ? {
            ...info,
            establishDate: info && info.establishDate ? this.$options.filters['date-format'](info.establishDate, 'YYYY-MM-DD') : '',
            dueDate: info && info.dueDate ? this.$options.filters['date-format'](info.dueDate, 'YYYY-MM-DD') : '',
          } : {
            certCode: '',
            establishDate: '',
            dueDate: '',
            tenantFileReqDTOs: [],
            type: this.type,
          };
          this.clearValidate();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clearValidate () {
      this.$nextTick(()=>{
        this.$refs.JZForm && this.$refs.JZForm.clearValidate();
      });
    },
    // 身份证发证日期验证
    validateEstablishDate (rule, value, callback) {
      this.$refs.JZForm.clearValidate();
      // 如果操作时间(止)没选，cb
      if (!this.form.dueDate || !value) {
        callback();
      } else {
        // 操作时间(止)有，进行判断
        if (this.compareDate(value, this.form.dueDate)) {
          // 如果起始在结束之前
          callback();
        } else {
          callback(new Error('身份证发证日期不可大于身份证到期日期，请重新选择'));
        }
      }
    },
    validateDueDate (rule, value, callback) {
      this.$refs.JZForm.clearValidate();
      if (!this.form.establishDate || !value) {
        callback();
      } else {
        // 操作时间(起)有
        if (this.compareDate(this.form.establishDate, value)) {
          callback();
        } else {
          callback(new Error('身份证到期日期不能小于身份证发证日期，请重新选择'));
        }
      }
    },
    compareDate (start, end) {
      return new Date(end).getTime() >= new Date(start).getTime();
    },
    handleEdit () {
      this.isEditing = true;
    },
    handleCancel () {
      let info = this.certificateLists.find(i=>i.type === this.type);
      info = info ? JSON.parse(JSON.stringify(info)) : null;
      this.form = info ? {
        ...info,
        establishDate: info && info.establishDate ? this.$options.filters['date-format'](info.establishDate, 'YYYY-MM-DD') : '',
        dueDate: info && info.dueDate ? this.$options.filters['date-format'](info.dueDate, 'YYYY-MM-DD') : '',
      } : {
        certCode: '',
        establishDate: '',
        dueDate: '',
        businessRange: '',
        tenantFileReqDTOs: [],
        type: this.type,
      };
      this.isEditing = false;
    },
    handleSave () {
      this.$refs.JZForm.validate(valid =>{
        if (valid) {
          let tenantFileReqDTOs = (this.form.tenantFileReqDTOs || []).map(i=>({
            ...i,
            type: this.type,
          }));
          this.$emit('updateMaterial', {...this.form, tenantFileReqDTOs}, this.type);
          this.isEditing = false;
        }
      });
    },
    handleUpdate () {
      this.$refs.JZForm.validate(valid =>{
        if (valid) {
          let tenantFileReqDTOs = (this.form.tenantFileReqDTOs || []).map(i=>({
            ...i,
            type: this.type,
          }));
          this.$emit('updateMaterial', {...this.form, tenantFileReqDTOs}, this.type);
        }
      });
    },
    handleRemove () {
      console.log(arguments[0]);
    },
    handleFileLists () {
      console.log(arguments[0]);
    },
    handleDelete (index) {
      this.form.tenantFileReqDTOs.splice(index, 1);
    },
    handleValidate () {

    },
    validateIdCode (rule, value, callback) {
      const reg1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
      const reg2 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[A-Z])$/;
      if (!value) {
        callback(new Error('请输入身份证号码'));
      } else if (!reg1.test(value) && !reg2.test(value)) {
        callback(new Error('输入格式有误，请重新输入'));
      } else {
        callback();
      }
    },
  },
  data () {
    return {
      isEditing: false,
      rules: {
        tenantFileReqDTOs: [
          { required: true, message: '请选择附件信息', trigger: ['blur', 'change'] },
        ],
        establishDate: [
          { required: true, message: '请选择身份证发证日期', trigger: ['blur', 'change'] },
          {trigger: ['blur', 'change'], validator: this.validateEstablishDate},
        ],
        dueDate: [
          { required: true, message: '请选择身份证到期日期', trigger: ['blur', 'change'] },
          {trigger: ['blur', 'change'], validator: this.validateDueDate},
        ],
        certCode: [
          { required: true, message: '请输入委托人身份证号', trigger: ['blur', 'change'] },
          { validator: this.validateIdCode, trigger: 'blur' },
        ],
      },
      form: {
        certCode: '',
        establishDate: '',
        dueDate: '',
        tenantFileReqDTOs: [],
        type: this.type,
      },
    };
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.content_block{
  padding: 0 20px 20px 20px;
  min-height: calc(100vh - 420px);
  .top{
    height: 40px;
    line-height: 40px;
    display: flex;
    b>span{
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: rgb(95, 106, 122);
      letter-spacing: 0px;
      margin-left: 10px;
      font-weight: normal;
      i{
        font-style: normal;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #FF5959;
        letter-spacing: 0;
        margin-left: 3px;
        margin-right: 3px;
      }
    }
    .btnContainer{
      flex: 1;
      text-align:right;
    }
  }
}
/deep/ .warningLabel{
  width: 116px;
  text-align: right;
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #929AA6;
  letter-spacing: 0;
  text-align: right;
  line-height: 20px;
}
/deep/ .warningContent{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1F2733;
  letter-spacing: 0;
  text-align: left;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  .fileContainer{
    flex: 1;
  }
}
.imgContainer{
  list-style: none;
  li{
    height: 40px;
    line-height: 20px;
    background: #F5F7FA;
    border-radius: 4px;
    display: flex;
    width:500px;
    padding: 10px 8px;
    margin-bottom: 8px;
    .left{
      flex: 1;
      display: flex;
      .el-link.el-link--primary {
        width:440px;
        display:inline-block;
        span.el-link--inner{
          width: 100%;
          span.name{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 420px;
            display:inline-block;
          }
        }
      }
    }
    img{
      width:16px;
      height:16px;
      margin-right: 4px;
    }
  }
}
</style>
